import { ErrorBoundary } from "@sentry/react";
import React, { Suspense } from "react";

import { GenieErrorComponent } from "@/components/error/genie-error";
import { getMSBaseUrl } from "@/utils/baseUrls.ts";
import { MICRO_SERVICES } from "@/utils/enums.ts";

import GenieLayout, { Loader } from "./genie-layout";

(window as any).baseUrl = getMSBaseUrl(MICRO_SERVICES.INSIGHTS);
(window as any).pdsBaseUrl = getMSBaseUrl(MICRO_SERVICES.PDS);

const GenieRemote = React.lazy(() =>
  // eslint-disable-next-line import/no-unresolved
  import("remoteApp/App").catch((err) => {
    console.error("Failed to load Genie module:", err);
    return { default: GenieErrorComponent };
  })
);

export const GenieRemoteWrapper: React.FC = () => {
  return (
    <ErrorBoundary>
      <Suspense fallback={<Loader />}>
        <GenieLayout>
          <GenieRemote />
        </GenieLayout>
      </Suspense>
    </ErrorBoundary>
  );
};
